export default __webpack_public_path__ + "static/media/coupon.8cc3ba10.svg";